import { ItemInstance } from '@headless-tree/core';

import { InternalTreeItem } from './types';

// virtual-core's deferred scrollToIndex retry calls getItemKey with an index clamped
// before the tree shrank; falling back to the index (its own default key) keeps it safe.
export const getVirtualItemKey = (
  items: ItemInstance<InternalTreeItem>[],
  index: number,
) => items[index]?.getItemData().id ?? index;
